import { Alert, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { ProgressiveDiscountEffect } from '../../../../../typings'
import { messages } from '../messages'
import { useNumbers } from 'ui/components/utils/useNumbers'

type Props = {
  progressive: ProgressiveDiscountEffect
}

export function ProgressiveDiscountRecap(props: Props) {
  const {
    progressive: { benefit, trigger },
  } = props

  const { formatList, $t } = useIntl()
  const { formatPercentual } = useNumbers()

  if (!trigger || !benefit) return null

  const mountList = (values: number[] | string[]) =>
    formatList(values, { type: 'disjunction' })

  return (
    <Alert variant="info">
      {$t(messages.progressive.recap, {
        quantityList: mountList(benefit.map(({ quantity }) => quantity)),
        discountList: mountList(
          benefit.map(({ discount }) => formatPercentual(discount))
        ),
        b: (content) => <Text variant="action1">{content}</Text>,
        sameItemsOnly: trigger.sameItemsOnly,
        lastQuantity: benefit[benefit.length - 1].quantity,
        lastDiscount: formatPercentual(benefit[benefit.length - 1].discount),
      })}
    </Alert>
  )
}
